angular.module('satv.playlist.pitch')

.factory('PitchEmailer', ['Pitch', '$window', 'PitchEmailModal', function(Pitch, $window, PitchEmailModal) {
    return {
        open: function(pitch) {
            Pitch.getEmail({
                hash: pitch.hash
            }, function(resp) {

              var url = '';
              if (resp.bcc.indexOf(';') === -1) {
                url = 'mailto:' + resp.bcc + '?subject=' + resp.subject + '&body=' + encodeURIComponent(resp.body);
              } else {
                url = 'mailto:?subject=' + resp.subject + '&body=' + encodeURIComponent(resp.body) + '&bcc=' + resp.bcc;
              }

              //there are limitations with respect to the length of a url and opening an email client.
              if (url.length > 1500) {
                  var modalInstance = PitchEmailModal.open({}, {
                      email: resp
                  });

                  modalInstance.then(function(result) {
                      url = url.replace('&body=' + encodeURIComponent(resp.body), '');
                      $window.location.replace(url);
                  });
              } else {
                  $window.location.replace(url);
              }
            });
        }
    };
}])
;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchEmailer.js